// extracted by mini-css-extract-plugin
export default {"saveRow":"e5b57c4b","addRow":"d359550b"};